<div class="px-6">
  <vwui-header>
    @if (!isIframe) {
      <vwui-logo class="vwui-logo" logoSrc="/assets/images/vwlogo.svg"></vwui-logo>
    } @else {
      <div class="flex items-center">
        <button class="mr-3" type="button" aria-label="back" appNavigateBack>
          <img src="/assets/icons/icon-16-arrow-left.svg" class="h-4 w-4" alt="back">
        </button>
        <h1 class="m-0">PRS beheer</h1>
      </div>
    }
    <div slot="action">
      <vwui-button id="add-ref" class="is-primary" *appHasRole="[authorities.editor, authorities.admin]" (click)="openProjectModal()">Referentie toevoegen</vwui-button>
    </div>
  </vwui-header>
</div>

<div class="flex items-center h-20 py-4 px-6 border-t border-b border-neutral-3 gap-2 justify-between w-full sticky -top-px z-50 bg-white">
  <div class="relative flex-1">
    <vwui-search placeholder="Zoeken door projecten"
      (vwuiFocus)="onFocus()"
      (vwuiBlur)="onBlur()"
      [formControl]="searchControl"
      (vwuiClear)="search(searchControl.value)"
      (keydown.enter)="search(searchControl.value)">
    </vwui-search>
    @if ((suggestions$ | async ); as suggestions) {
      <div [class.invisible]="!showSuggestions"
        class="flex flex-col z-10 w-full border border-neutral-3 shadow-vwui-large rounded-sm border-t-0 bg-white absolute top-full">
        @for (suggestion of suggestions; track suggestion) {
          <button
            class="px-4 py-1 hover:bg-neutral-4 font-normal text-left truncate"
            [innerHTML]="suggestion" (mousedown)="useSuggestion(suggestion)">
          </button>
        }
      </div>
    }
  </div>
  <app-search-filter [facets]="(facets$|async) || []" [formControl]="filterControl"></app-search-filter>
  @if (!isIframe) {
    <div class="ml-auto">
      <vwui-btn-option-group [formControl]="listModeControl">
        <vwui-btn-option value="table" icon="vwui-table-normal"></vwui-btn-option>
        <vwui-btn-option value="grid" icon="vwui-grid"></vwui-btn-option>
      </vwui-btn-option-group>
    </div>
  }
</div>

@if ((paginator$ | async); as paginator) {
  <div>
    <div
      infinite-scroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="paginator.loadMore()"
      >
      @if (listModeControl.value === 'table') {
        <app-project-reference-table [projectReferences]="paginator.content$|async"></app-project-reference-table>
      }
      @if (listModeControl.value === 'grid') {
        <app-project-reference-grid [projectReferences]="paginator.content$|async"></app-project-reference-grid>
      }
    </div>
  </div>
}
